import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  Chip,
  IconButton,
  Paper,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { Box } from '@mui/system';
import { isEmpty } from 'lodash';

import BoxActionPermission from '../../../components/box/BoxActionPermission/BoxActionPermission';
import BoxTableNotFound from '../../../components/box/BoxTableNotFound/BoxTableNotFound';
import TablePaginationMain from '../../../components/table-pagination/TablePaginationMain/TablePaginationMain';
import TableRowLoading from '../../../components/table-row/TableRowLoading/TableRowLoading';
import TypographyLinkPrimary from '../../../components/typography/TypographyLinkPrimary/TypographyLinkPrimary';
import { withRouter } from '../../../components/withRouter/withRouter';
import { decryptData, encryptData } from '../../../services/modules/Crypto/Crypto.service';
import messageHelper from '../../../store/message/message.helper';
import { getListSalesInvoice } from '../../../store/sales/sales.action';
import {
  REACT_APP_SALES_SALES_INVOICE_CREATE_NEW_URL,
  REACT_APP_SALES_SALES_INVOICE_DETAILS_TEMPLATE_URL,
} from '../../../utils/configs/url.config';
import { STATUS_REQUEST_LIST_SALES_INVOICE_PENDING } from '../../../utils/constants/store.constant';
import {
  calculationColumns,
  columnsTableHeaderSalesInvoice,
} from '../../../utils/data/display/table-list-sales-invoice';
import {
  iconSalesInvoiceList,
  tooltipSalesInvoice,
} from '../../../utils/data/display/tooltip-sales-invoice';
import {
  salesDeliveryStatus,
  salesInvoiceStatus,
} from '../../../utils/data/label-value/sales-status';
import {
  DEFAULT_SALES_INVOICE_SEARCH_FE_PARAMS,
  TERSIER_DEFAULT_LIST_PARAMS,
} from '../../../utils/default/params.default';
import arrHelp from '../../../utils/helpers/array.helpers';
import formatHelp from '../../../utils/helpers/format.helpers';
import objHelper from '../../../utils/helpers/object.helper';
import strHelp from '../../../utils/helpers/string.helpers';

import TableHeadSearchSalesInvoice from './TableHeadSearchSalesInvoice/TableHeadSearchSalesInvoice';
import { styles } from './SalesInvoiceList.styles';

class SalesInvoiceList extends Component {
  constructor(props) {
    super(props);

    const { handleSelectedStatusPage } = props;

    this.isHandleSelectedStatusPageFunction = typeof handleSelectedStatusPage === 'function';

    this.state = {
      rowsPerPage: TERSIER_DEFAULT_LIST_PARAMS.paginate,
    };

    this.getSearchParamsSalesInvoice = this.getSearchParamsSalesInvoice.bind(this);

    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

    this.handleClickActionSalesInvoice = this.handleClickActionSalesInvoice.bind(this);
  }

  handleClickActionSalesInvoice(event) {
    const { name: newStatusPage, value } = event.currentTarget;

    const decryptedValue = decryptData(value, false);

    if (this.isHandleSelectedStatusPageFunction) {
      this.props.handleSelectedStatusPage(newStatusPage, decryptedValue);
    }
  }

  getSearchParamsSalesInvoice() {
    const { sales } = this.props;
    const { salesInvoiceData } = sales;

    let searchParamsSalesInvoice = objHelper.filterKeyObj(
      salesInvoiceData,
      [],
      DEFAULT_SALES_INVOICE_SEARCH_FE_PARAMS,
    );

    if (!isEmpty(searchParamsSalesInvoice)) {
      searchParamsSalesInvoice = objHelper.changeSuffixKey(
        searchParamsSalesInvoice,
        'search_',
        true,
      );
    }

    return searchParamsSalesInvoice;
  }

  async handleChangePage(event, newPage) {
    event.preventDefault();

    const { sales } = this.props;
    const { salesInvoiceData } = sales;

    if (!salesInvoiceData) {
      return;
    }

    const { next_page_url, current_page, per_page: paginate } = salesInvoiceData;

    if (!next_page_url && current_page < newPage + 1) {
      return;
    }

    let searchParamsSalesInvoice = this.getSearchParamsSalesInvoice();

    await this.props.getListSalesInvoice({
      paginate,
      page: newPage + 1,
      ...searchParamsSalesInvoice,
    });
  }

  async handleChangeRowsPerPage(event) {
    const { value: newRowsPerPage } = event.target;

    const { t, sales } = this.props;

    const { salesInvoiceData } = sales;

    if (!salesInvoiceData) {
      return;
    }

    const { next_page_url, current_page, per_page: paginate } = salesInvoiceData;

    if (Number(paginate) === Number(newRowsPerPage)) {
      return;
    }

    if (!next_page_url && paginate < newRowsPerPage && current_page === 1) {
      this.props.setMessageFailed(
        t('dashboard.sales.sales-invoice.message.max-data.primary'),
        t('dashboard.sales.sales-invoice.message.max-data.secondary'),
      );

      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      rowsPerPage: newRowsPerPage,
    }));

    let searchParamsSalesInvoice = this.getSearchParamsSalesInvoice();

    await this.props.getListSalesInvoice({
      paginate: newRowsPerPage,
      ...searchParamsSalesInvoice,
    });
  }

  async componentDidMount() {
    const { rowsPerPage: paginate } = this.state;

    await this.props.getListSalesInvoice({
      paginate,
      isShowMessage: false,
    });
  }

  render() {
    const { rowsPerPage } = this.state;

    const { t, auth, classes, sales } = this.props;

    const { permissions } = auth.data;
    const { salesInvoiceData } = sales;

    let salesInvoiceList = [];

    let currPagination = rowsPerPage;

    if (salesInvoiceData) {
      if (salesInvoiceData.data) {
        if (Array.isArray(salesInvoiceData.data)) {
          salesInvoiceList = salesInvoiceData.data;
        }
      }

      if (salesInvoiceData.per_page) {
        currPagination = Number(salesInvoiceData.per_page);
      }
    }

    const tableHeaderSalesInvoice = columnsTableHeaderSalesInvoice(t);

    return (
      <Box className={classes.boxContainerTable}>
        <Paper elevation={0}>
          <TableContainer className={'tableContainerConstantHeightMDSizeConstantLayoutPrimary'}>
            <Table stickyHeader className='tableMain' aria-label='table-sales-invoice-list'>
              <TableHeadSearchSalesInvoice dataHeaders={tableHeaderSalesInvoice} />
              <TableBody className='primaryTableBody'>
                {sales.statusRequest === STATUS_REQUEST_LIST_SALES_INVOICE_PENDING && (
                  <TableRowLoading
                    rowsAmount={rowsPerPage}
                    columnsAmount={tableHeaderSalesInvoice.length}
                  />
                )}
                {salesInvoiceList &&
                  sales.statusRequest !== STATUS_REQUEST_LIST_SALES_INVOICE_PENDING &&
                  salesInvoiceList.map((singleSalesInvoice, index) => {
                    const baseUrl = strHelp.templateString(
                      REACT_APP_SALES_SALES_INVOICE_DETAILS_TEMPLATE_URL,
                      singleSalesInvoice,
                    );

                    return (
                      <TableRow
                        hover
                        key={index}
                        tabIndex={-1}
                        className={'hoverEntireRow'}
                        onDoubleClick={() => this.props.navigate(baseUrl)}
                      >
                        {tableHeaderSalesInvoice.map((columnTableHeader, indexColumnHeader) => {
                          let valueData = singleSalesInvoice[columnTableHeader.name];

                          if (columnTableHeader.name === 'action') {
                            return (
                              <TableCell
                                key={indexColumnHeader}
                                align={columnTableHeader.align}
                                className='tableCellListData'
                              >
                                {tooltipSalesInvoice(t).map((tooltipData, index) => {
                                  return (
                                    <BoxActionPermission
                                      key={index}
                                      permissionsUser={permissions}
                                      permissionRequired={tooltipData.permission}
                                    >
                                      <Tooltip title={tooltipData.title}>
                                        <IconButton
                                          name={tooltipData.name}
                                          value={encryptData(JSON.stringify(singleSalesInvoice))}
                                          onClick={this.handleClickActionSalesInvoice}
                                          className={classes.iconButtonContainer}
                                        >
                                          <SvgIcon component={iconSalesInvoiceList[index]} />
                                        </IconButton>
                                      </Tooltip>
                                    </BoxActionPermission>
                                  );
                                })}
                                {valueData}
                              </TableCell>
                            );
                          }

                          // formating date following localzone
                          if (columnTableHeader.name === 'transaction_date') {
                            valueData = formatHelp.getReadableDateV2(valueData);
                          }

                          if (columnTableHeader.name === 'sales_invoice_no') {
                            return (
                              <TableCell key={indexColumnHeader}>
                                <TypographyLinkPrimary
                                  baseUrl={baseUrl}
                                  typographyValue={valueData}
                                />
                              </TableCell>
                            );
                          }

                          // formating value of nominal column
                          if (calculationColumns.includes(columnTableHeader.name)) {
                            valueData = formatHelp.currencyFormatWithRegex(valueData);
                          }

                          // container value status with Chip
                          if (
                            columnTableHeader.name === 'status' ||
                            columnTableHeader.name === 'status_delivery'
                          ) {
                            let selectedChipStatus = arrHelp.filterObjDataWithID(
                              salesInvoiceStatus(t),
                              'value',
                              valueData,
                            );

                            if (columnTableHeader.name === 'status_delivery') {
                              selectedChipStatus = arrHelp.filterObjDataWithID(
                                salesDeliveryStatus(t),
                                'value',
                                valueData,
                              );
                            }

                            let label = t('base.sales-invoice-status.open');
                            let colorChip = 'chipSecondaryStatus';

                            // get color and label status sales invoice
                            if (!isEmpty(selectedChipStatus)) {
                              label = selectedChipStatus.label;
                              colorChip = selectedChipStatus.colorChip;
                            }

                            return (
                              <TableCell key={indexColumnHeader}>
                                <Chip size='small' color={colorChip} label={label} />
                              </TableCell>
                            );
                          }

                          return (
                            <TableCell key={indexColumnHeader} align={columnTableHeader.align}>
                              {valueData}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            {!salesInvoiceList.length &&
              sales.statusRequest !== STATUS_REQUEST_LIST_SALES_INVOICE_PENDING && (
                <BoxTableNotFound
                  textNotFound={t('dashboard.sales.sales-invoice.table.body-not-found')}
                  textButton={t('dashboard.sales.sales-invoice.button.add-sales-invoice')}
                  handleClickedButton={() => {
                    this.props.navigate(REACT_APP_SALES_SALES_INVOICE_CREATE_NEW_URL);
                  }}
                  isExistButton={true}
                />
              )}
          </TableContainer>
          <TablePaginationMain
            page={salesInvoiceData ? salesInvoiceData.current_page - 1 : 0}
            prev_page={salesInvoiceData ? salesInvoiceData.prev_page_url : null}
            next_page={salesInvoiceData ? salesInvoiceData.next_page_url : null}
            rowsPerPage={currPagination}
            isLoadingData={
              sales.statusRequest === STATUS_REQUEST_LIST_SALES_INVOICE_PENDING ||
              !salesInvoiceList.length
            }
            labelRowsPerPage={t('label.table.pagination.primary.rows-per-page')}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    );
  }
}

SalesInvoiceList.defaultProps = {
  isUseChangedPageOnDetails: false,
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    sales: state.sales,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListSalesInvoice: (paramsGetListSalesInvoice) =>
      dispatch(getListSalesInvoice(paramsGetListSalesInvoice)),
    setMessageFailed: (primaryMessage, secondaryMessage) =>
      dispatch(messageHelper.failedMessage(dispatch, primaryMessage, secondaryMessage, false)),
  };
};

// adding style into component
const stylingSalesInvoiceList = withStyles(styles)(SalesInvoiceList);

// adding translation into component
const SalesInvoiceListTranslate = withTranslation()(stylingSalesInvoiceList);

const SalesInvoiceListWithRouter = withRouter(SalesInvoiceListTranslate);

// connect component with action and state
const ConnectedSalesInvoiceList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SalesInvoiceListWithRouter);

export default ConnectedSalesInvoiceList;
